<template>
    <div class="zy-box zy-box-diff1">
        <Breadcrumb></Breadcrumb>
        <el-row class="zy-school" id="zy-box" type="flex" justify="space-between">
            <el-col :span="16">
                <div>
                    <el-tabs v-model="selectType" type="border-card" slot="content" class="rank-box zy-list" @tab-click="handleChangeCard" :class="selectType != '1'?'zytb-school-major-diff':''">
                        <el-tab-pane :name="card.type" :label="card.name + card.count +'所'" v-for="(card,index) in cardList" :key="index">
                            <el-row class="zy-search">
                                <el-col :span="4" @mouseenter.native="hoverMenuHandler()" @mouseleave.native="hoverMenuHandler()">
                                    {{typeMoreList[activeMoreIndex].name}}<span class="el-icon-arrow-down" v-if="!hoverMenuStatus"></span><span class="el-icon-arrow-up" v-else></span>
                                    <ul class="menu-tools-ul" v-if="hoverMenuStatus">
                                        <li @click.stop="changeSearchTypeHandler(index)" v-for="(item,index) in typeMoreList" :key="index">{{item.name}}</li>
                                    </ul>
                                </el-col>
                                <el-col :span="20">
                                    <el-select v-model="valueSchool" multiple filterable remote :remote-method="getSearchSchoolListHandler" :loading="loading" reserve-keyword placeholder="请输入学校" v-if="activeMoreIndex == 0">
                                        <el-option v-for="item in optionsSchool" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <img src="../../assets/images/sousuo.png" alt="搜索" @click="resetGetSchoolListHandler" @mouseenter="isShowSearch=!isShowSearch" @mouseleave="isShowSearch=!isShowSearch" v-if="!isShowSearch">
                                    <img src="../../assets/images/sousuo-diff.png" alt="搜索" @click="resetGetSchoolListHandler" @mouseenter="isShowSearch=!isShowSearch" @mouseleave="isShowSearch=!isShowSearch" v-if="isShowSearch">
                                    <el-select v-model="valueMajor" multiple filterable remote :remote-method="geSearchSpecialListHandler" placeholder="请输入专业" v-if="activeMoreIndex == 1">
                                        <el-option v-for="item in optionsMajor" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <img src="../../assets/images/sousuo.png" alt="搜索" @click="resetGetSchoolListHandler" @mouseenter="isShowSearch1=!isShowSearch1" @mouseleave="isShowSearch1=!isShowSearch1" v-if="!isShowSearch1">
                                    <img src="../../assets/images/sousuo-diff.png" alt="搜索" @click="resetGetSchoolListHandler" @mouseenter="isShowSearch1=!isShowSearch1" @mouseleave="isShowSearch1=!isShowSearch1" v-if="isShowSearch1">
                                    <el-select v-model="valueJob" multiple filterable remote :remote-method="getSearchJobListHandler" placeholder="请输入职业" v-if="activeMoreIndex == 2">
                                        <el-option v-for="item in optionsJob" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <img src="../../assets/images/sousuo.png" alt="搜索" @click="resetGetSchoolListHandler" @mouseenter="isShowSearch2=!isShowSearch2" @mouseleave="isShowSearch2=!isShowSearch2" v-if="!isShowSearch2">
                                    <img src="../../assets/images/sousuo-diff.png" alt="搜索" @click="resetGetSchoolListHandler" @mouseenter="isShowSearch2=!isShowSearch2" @mouseleave="isShowSearch2=!isShowSearch2" v-if="isShowSearch2">
                                </el-col>
                            </el-row>
                            <div class="batch-search-list">
                                <div class="province-list">
                                    <div class="title-box">省份：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" :animate="false" :speed="0" height="84" width="670" viewBox="0 0 670 84" v-if="provinceList.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                        <rect x="10" y="30" width="670" height="20" />
                                        <rect x="10" y="60" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in provinceList" :key="index" :class="item.flag?'active-tag':''" @click="activeTagHandler(item, index)">{{item.name}}</a>
                                    </div>
                                </div>
                                <div class="province-list">
                                    <div class="title-box">院校类型：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" :animate="false" :speed="0" height="56" width="670" viewBox="0 0 670 56" v-if="typeList.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                        <rect x="10" y="30" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList" :key="index" :class="activeTag1 == index?'active-tag':''" @click="activeTagHandler1(index)">{{item.dic_value}}</a>
                                    </div>
                                </div>
                                <div class="province-list" v-if="showSearchAll">
                                    <div class="title-box">办学类型：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" :animate="false" :speed="0" height="30" width="670" viewBox="0 0 670 30" v-if="typeList1.length == 1">
                                        <rect x="10" y="0" width="70" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList1" :class="activeTag2 == index?'active-tag':''" @click="activeTagHandler2(index)" :key="index">{{item.dic_value}}</a>
                                    </div>
                                </div>
                                <div class="province-list" v-if="showSearchAll">
                                    <div class="title-box">招生类型：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" :animate="false" :speed="0" height="30" width="670" viewBox="0 0 670 30" v-if="typeList2.length == 1">
                                        <rect x="10" y="0" width="170" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList2" :class="activeTag3 == index?'active-tag':''" @click="activeTagHandler3(index)" :key="index">{{item.dic_value}}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="choice-box" @click="showSearchAllhandler">查看全部筛选条件<i :class="showSearchAll? 'el-icon-arrow-up':'el-icon-arrow-down'"></i></div>
                            <div v-if="showBoxStatus" style="margin-top: 27px">
                                <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" :animate="false" :speed="0" height="130" width="670" viewBox="0 0 670 130" v-for="(item,index) in activeCount" :key="index">
                                    <rect x="80" y="20" width="117" height="20" />
                                    <rect x="80" y="45" width="140" height="23" />
                                    <rect x="80" y="85" width="250" height="13" />
                                    <rect x="550" y="20" width="110" height="60" />
                                    <circle cx="35" cy="50" r="32" />
                                    <rect x="0" y="129" width="725" height="1" />
                                </ContentLoader>
                            </div>
                            <el-collapse v-model="activeNames" v-else-if="schoolList.length > 0">
                                <el-collapse-item :name="(index+1)+''" v-for="(item,index) in schoolList" :key="index" @click.native.once="getSpecialListHandler(index,item.scl_id,item.year)">
                                    <template slot="title">
                                        <el-row class="collapse-box">
                                            <el-col :span="3">
                                                <el-image :src="'https://gaokao.zmpajx.com/pic/' + item.scl_id + '.jpg'" alt="大学logo">
                                                    <div slot="error" class="image-slot">
                                                        <img src="../../assets/images/scl_default.png" alt="大学logo">
                                                    </div>
                                                </el-image>
                                            </el-col>
                                            <el-col :span="17">
                                                <div class="zytb-school-name" @click="schoolDetailHandler(item.scl_id)">{{item.scl_name}}</div>
                                                <div class="zytb-school-tag">
                                                    <span v-if="item.name">{{item.name}}</span>
                                                    <span v-if="item.school_type">{{item.school_type}}</span>
                                                    <span v-if="item.school_nature">{{item.school_nature}}</span>
                                                    <span v-if="item.school_nature_type">{{item.school_nature_type}}</span>
                                                </div>
                                                <div class="zytb-school-count zytb-school-count-diff">
                                                    <span v-if="item.stu_num">{{item.year}}计划{{item.stu_num}}人</span>
                                                    <span v-else>{{item.year}}计划--人</span>
                                                    <span v-if="item.score_min">{{item.year}}年最低分{{item.score_min}}</span>
                                                    <span v-if="item.min_section">{{item.year}}年最低位次{{item.min_section}}</span>
                                                </div>
                                            </el-col>
                                            <el-col :span="4">
                                                <div class="zytb-school-fx" :class="'zytb-school-fx-' + selectType">
                                                    <div class="zytb-school-tj">
                                                        <div>推荐度</div>
                                                        <span>{{item.percent}}</span><span class="zytb-school-fx-span">%</span>
                                                    </div>
                                                    <div v-if="selectType == '1'" class="zytb-school-ms">
                                                        风险极大<br>建议不报
                                                    </div>
                                                    <div v-else-if="selectType == '2'" class="zytb-school-ms">
                                                        风险较大<br>建议填报<br>冷门专业
                                                    </div>
                                                    <div v-else class="zytb-school-ms">
                                                        稍有风险<br>建议规避<br>热门专业
                                                    </div>
                                                </div>
                                                <div class="con-clear"></div>
                                                <div class="zytb-school-major">可选专业({{item.special_count}})个</div>
                                            </el-col>
                                        </el-row>
                                    </template>
                                    <div v-if="!item.majorList">
                                        <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="50" width="670" v-for="item in item.special_count" :key="item">
                                            <rect x="00" y="0" width="60" height="50" />
                                            <rect x="85" y="0" width="117" height="20" />
                                            <rect x="85" y="30" width="180" height="20" />
                                            <rect x="580" y="13" width="90" height="30" />
                                        </ContentLoader>
                                    </div>
                                    <div v-else>
                                        <el-row class="collapse-box collapse-box-diff" v-for="(item1,index1) in item.majorList" :key="index1">
                                            <el-col :span="20">
                                                <el-row class="zytb-school-name">
                                                    <el-col :span='4' v-if="item1.percent"><span>{{item1.percent}}%<div>专业概率</div></span></el-col>
                                                    <el-col :span='20'>
                                                        <div>{{item1.spname}}</div>
                                                        <div class="zytb-school-count">
                                                            <span v-if="item1.sp_num">{{item1.year}}计划{{item1.sp_num}}人</span>
                                                            <span v-else>{{item1.year}}计划--人</span>
                                                            <span v-if="item1.sp_min">{{item1.year}}年最低分{{item1.sp_min}}</span>
                                                            <span v-else>{{item1.year}}--</span>
                                                            <span v-if="item1.sp_min_section">{{item1.year}}年最低位次{{item1.sp_min_section}}</span>
                                                            <span v-else>{{item1.year}}年最低位次--</span>
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </el-col>
                                            <el-col :span="4">
                                                <button @click="addZhiYuanHandler(item1,index,index1)" v-if="!item1.active">加入志愿表</button>
                                                <button class="zytb-school-btn" v-else><img src="../../assets/images/ytj.png">已添加</button>
                                            </el-col>
                                            <div class="con-clear"></div>
                                        </el-row>
                                    </div>
                                </el-collapse-item>
                                <el-collapse-item v-if="(!isVip) && card.count >3 && schoolList.length >=3" class="el-item-diff">
                                    <template slot="title">
                                        <el-row class="collapse-box">
                                            <el-col :span="3">
                                                <img src="https://gaokao.zmpajx.com/pic/140.jpg" alt="大学logo">
                                            </el-col>
                                            <el-col :span="17">
                                                <div class="zytb-school-name">1</div>
                                                <div class="zytb-school-tag">
                                                    <span>1</span>
                                                    <span>1</span>
                                                    <span>1</span>
                                                </div>
                                                <div class="zytb-school-count">
                                                    <span>2020计划1人</span>
                                                    <span>2019年最低分1</span>
                                                    <span>2019年最低位次1</span>
                                                </div>
                                            </el-col>
                                            <el-col :span="4">
                                                <div class="zytb-school-fx" :class="'zytb-school-fx-' + selectType">
                                                    <div><span>1</span><span class="zytb-school-fx-span">%</span></div>
                                                    <div v-if="selectType == '1'">
                                                        风险极大<br>建议不报
                                                    </div>
                                                    <div v-else-if="selectType == '2'">
                                                        风险较大<br>建议填报<br>冷门专业
                                                    </div>
                                                    <div v-else>
                                                        稍有风险<br>建议规避<br>热门专业
                                                    </div>
                                                </div>
                                                <div class="con-clear"></div>
                                                <div class="zytb-school-major">可选专业(1)个</div>
                                            </el-col>
                                        </el-row>
                                    </template>
                                </el-collapse-item>
                            </el-collapse>
                            <div v-if="!showBoxStatus">
                                <div v-if="card.count == 0 || showDataStatus" class="no-data-box" :class="showSearchAll?'no-data-box-diff':''">
                                    <img src="../../assets/images/null.png" alt="没有数据">
                                    <p>没有匹配到合适的学校</p>
                                </div>
                            </div>
                            <el-row class="zy-active" v-if="!isVip && card.count > 3 && schoolList.length >=3 && !showBoxStatus">
                                <p>激活会员查看<span>所有高薪专业数据</span>智能填报志愿等VIP功能等你使用</p>
                                <el-button @click="activeVipHandler">激活会员</el-button>
                            </el-row>
                            <el-pagination background layout="prev, pager, next, jumper" :total="totalData" :page-size="10" @current-change="getSchoolListHandler" :current-page.sync="currentPage" v-if="totalData > 0 && isVip && !showBoxStatus">
                            </el-pagination>
                        </el-tab-pane>
                    </el-tabs>
                    <div class="zy-text" v-if="gkInfor.score">
                        <div @mouseenter="linkShowState('true')" @mouseleave="linkShowState('false')" :style="{'text-align':'right'}">
                            {{gkInfor.subject}} <span></span> {{gkInfor.score}} <span></span> <a>{{selectPatch.batch}} <i class="el-icon-arrow-down el-icon--right" v-if="linkShow=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="linkShow=='true'"></i></a>
                            <div class="con-score-section" v-if="gkInfor.section_line > 0">结合往年数据分析全省排名：{{gkInfor.section_line}}</div>
                            <div class="con-score-section" v-else>结合往年数据分析全省排名：--</div>
                            <el-menu v-show="linkShow=='true'">
                                <div v-for="(item,index) in batchList" :key="index">
                                    <li v-if="gkInfor.score < item.grade &&(Object.keys(imitate_form).length == 0 || Object.keys(imitate_form).length != 0 && index != 0 && index != 3)">
                                        <div class="major-patch">{{item.name}}({{item.year}}批次线：{{item.grade}})</div>
                                        <div class="major-patch-bkx">不可选</div>
                                    </li>
                                    <li v-if="gkInfor.score >= item.grade && ( Object.keys(imitate_form).length == 0 || Object.keys(imitate_form).length != 0 && index != 0 && index != 3)" @click="batchActiveHandler(index)">
                                        <div>{{item.name}}({{item.year}}批次线：{{item.grade}})</div>
                                        <img src="../../assets/images/xz.png" alt="选中" v-if="isBatchActive == index">
                                        <img src="../../assets/images/dxk.png" alt="未选中" v-else>
                                    </li>
                                </div>
                            </el-menu>
                        </div>
                        <span v-if="Object.keys(imitate_form).length == 0" class="con-score-span" @click="showGkInforHandler"><img src="../../assets/images/edit.png" /> </span>
                    </div>
                </div>
            </el-col>
            <el-col :span="7" class="zyb-box zyb-box-hh" v-if="zybStatus" :class="scrollTag?'fixed-top':''" id="fixZyb">
                <el-card>
                    <div class="grid-content">
                        <el-row class="zyb-title">
                            <el-col :span="20">
                                <img src="../../assets/images/zyb.png" alt="志愿表" class="zyb-img">
                                {{ imitate_form.exam_name }}志愿表
                            </el-col>
                            <el-col :span="4"><span @click="removePlanHandler">清空</span></el-col>
                        </el-row>
                        <div class="zyb-avg-percent">录取总概率：<span>{{activePlanObj.avg_percent}}%</span></div>
                        <GeminiScrollbar class="zyb-bar">
                            <el-collapse class="zyb-batch" v-model="activeZybNames" :class=" divWidth ? 'zyb-batch-diff' : 'zyb-batch-diff1'">
                                <template v-for="(item, key) in batchKeyList" v-if="activePlanObj[item]">
                                    <el-collapse-item :key="item.toString()" :name="item.toString()" v-if="activePlanObj[item].count > 0">
                                        <template slot="title">
                                            {{activePlanObj[item].local_batch_type}}({{activePlanObj[item].count}})个
                                        </template>
                                        <vuedraggable v-model="activePlanObj[item].plan_data" element="ul" class="zyb-draggable" animation="300" :data-index="item" @end="draggableSchoolList">
                                            <el-row class="zyb-major" v-for="(item1,index1) in activePlanObj[item].plan_data" :key="index1">
                                                <div v-if="item1.specialty_data.length > 0">
                                                    <el-col :span="4">
                                                        <div class="zy-type">
                                                            {{item1.plan_type|planType}}
                                                            <div>志愿</div>
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="20">
                                                        <el-collapse v-model="activeDetNames">
                                                            <el-collapse-item class="tzy-collapse-item" :name="item1.plan_scl.scl_id" :key="item1.plan_scl.scl_id">
                                                                <template slot="title">
                                                                    <el-col :span="22" style="white-space: break-spaces;">{{item1.plan_scl.scl_name}}({{item1.specialty_data.length}})</el-col>
                                                                    <el-col :span="1">
                                                                        <img src="../../assets/images/delete.png" alt="删除" title="删除" @click.stop="deleteSchoolhandler(item1,index1,item)">
                                                                    </el-col>
                                                                    <el-col :span="1">
                                                                        <img src="../../assets/images/move.png" alt="移动" title="移动">
                                                                    </el-col>
                                                                </template>
                                                                <div v-for="(item2,index2) in item1.specialty_data" :key="index2" class="zyb-major-infor"><span class="zyb-major-title">{{index2+1}}.{{item2.spname}} </span><span @click.stop="deleteMajorhandler(item,index1,index2,item,item1,item2)" class="zyb-major-delete">删除</span>
                                                                    <div class="zyb-major-percent">录取概率：<span>{{item2.percent?item2.percent:'-'}}%</span></div>
                                                                </div>
                                                            </el-collapse-item>
                                                        </el-collapse>
                                                    </el-col>
                                                </div>
                                            </el-row>
                                        </vuedraggable>
                                    </el-collapse-item>
                                </template>
                            </el-collapse>
                        </GeminiScrollbar>
                    </div>
                </el-card>
                <div class="add-zyb-btn">
                    <el-button @click="savePlanHandler">保存志愿表</el-button>
                    <!-- <el-button @click="planSmartHandler">一键填报</el-button> -->
                </div>
            </el-col>
            <el-col :span="7" class="zyb-box" v-else :class="scrollTag?'fixed-top':''" id="fixZyb">
                <el-card>
                    <div class="grid-content">
                        <el-row class="no-data-content">
                            <el-col :span="20">
                                <img src="../../assets/images/zyb.png" alt="志愿表" class="zyb-img">
                                {{ imitate_form.exam_name }}志愿表
                            </el-col>
                        </el-row>
                        <el-row class="no-data-box">
                            <img src="../../assets/images/null.png" alt="没有数据">
                            <p>暂无志愿信息</p>
                        </el-row>
                    </div>
                </el-card>
                <!-- <el-button @click="planSmartHandler">一键填报</el-button> -->
            </el-col>
        </el-row>
        <!-- <el-dialog v-if="showPlanSmart" title="提示" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-save-plan">
            <img src="../../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
            <img src="../../assets/images/close.png" alt="关闭" @click="showPlanSmart = false">
            <div slot="footer" class="dialog-footer">
                <p>使用一键填报将会清空表内已填报的志愿，是否继续？</p>
                <div>
                    <el-button @click="showPlanSmart = false" class="vip-btn1">取消</el-button>
                    <el-button @click="planSmartSubmitHandler" class="vip-btn2">保存</el-button>
                </div>
            </div>
        </el-dialog> -->
    </div>
</template>
<script>
import vuedraggable from "vuedraggable"
import { mapState } from "vuex"
import { getScoreLine, getSearchDic, getSchoolList, getSpecialList, getSearchSchoolList, geSearchSpecialList, getSearchJobList, planSmartSubmit, getVirtualHistoryData, getPlanCount } from "@/api/zhiyuan"
import { getHistoryData } from "@/api/home"
import { ContentLoader } from 'vue-content-loader'

export default {
    components: {
        vuedraggable,
        ContentLoader,
    },
    data() {
        return {
            currentPage: 1,
            isShowSearch: false,
            isShowSearch1: false,
            isShowSearch2: false,
            showDataStatus: false,
            totalData: 0,
            showBoxStatus: true,
            config: {
                width: '200px',
                height: '18px',
                background: '#ddd'
            },
            cardList: [{ name: '需冲刺', count: '--', type: '1' }, { name: '较稳妥', count: '--', type: '2' }, { name: '可保底', count: '--', type: '3' }],
            provinceList: [
                { name: "全部", flag: true },
            ],
            typeList: [
                { dic_value: '全部' },
            ],
            typeList1: [
                { dic_value: '全部' },
            ],
            typeList2: [
                { dic_value: '全部' },
            ],
            activeNames: [],
            activeZybNames: [],
            activeDetNames: [],
            linkShow: 'false',
            // batchList: [{
            //         batch: '本科提前批',
            //         grade: '',
            //         local_batch_type: '6'
            //     },{
            //         batch: '本科一批',
            //         grade: '',
            //         local_batch_type: '7'
            //     },
            //     {
            //         batch: '本科二批',
            //         grade: '',
            //         local_batch_type: '8'
            //     },
            //     {
            //         batch: '专科提前批',
            //         grade: '',
            //         local_batch_type: '11'
            //     },
            //     {
            //         batch: '专科批',
            //         grade: '',
            //         local_batch_type: '10'
            //     }
            // ],
            batchList: JSON.parse(sessionStorage.getItem('batchList')),
            batchObj: JSON.parse(sessionStorage.getItem('batchObj')),
            subjectObj: JSON.parse(sessionStorage.getItem('subjectObj')),
            activeCount: 3,
            isBatchActive: 0,
            showSearchAll: false,
            activeTag: 0,
            activeTag1: 0,
            activeTag2: 0,
            activeTag3: 0,
            zybStatus: false,
            gkInfor: {},
            selectPatch: '',
            selectType: '1',
            selectProvince: [],
            selectNature: '',
            selectNatureType: '',
            selectSclType: '',
            schoolList: [],
            isVip: false,
            schoolListArr: [],
            has_code: 0,
            // savePlanAreaObj: {
            //     '41': {
            //         6: {
            //             local_batch_type: '本科提前批',
            //             local_batch_id: '6',
            //             scl_count: 5,
            //             major_count: 12,
            //             plan_data: []
            //         },
            //         7: {
            //             local_batch_type: '本科一批',
            //             local_batch_id: '7',
            //             scl_count:12,
            //             major_count: 5,
            //             plan_data: []
            //         },
            //         8: {
            //             local_batch_type: '本科二批',
            //             local_batch_id: '8',
            //             scl_count: 12,
            //             major_count: 5,
            //             plan_data: []
            //         },
            //         11: {
            //             local_batch_type: '专科提前批',
            //             local_batch_id: '11',
            //             scl_count: 5,
            //             major_count: 12,
            //             plan_data: []
            //         },
            //         10: {
            //             local_batch_type: '专科批',
            //             local_batch_id: '10',
            //             scl_count: 12,
            //             major_count: 5,
            //             plan_data: []
            //         }
            //     },
            //     '51': {
            //         6: {
            //             local_batch_type: '本科提前批',
            //             local_batch_id: '6',
            //             scl_count: 2,
            //             major_count: 3,
            //             plan_data: []
            //         },
            //         7: {
            //             local_batch_type: '本科一批',
            //             local_batch_id: '7',
            //             scl_count: 9,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         8: {
            //             local_batch_type: '本科二批',
            //             local_batch_id: '8',
            //             scl_count: 9,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         11: {
            //             local_batch_type: '专科提前批',
            //             local_batch_id: '11',
            //             scl_count: 3,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         10: {
            //             local_batch_type: '专科批',
            //             local_batch_id: '10',
            //             scl_count: 9,
            //             major_count: 6,
            //             plan_data: []
            //         }
            //     },
            //     '61': {
            //         6: {
            //             local_batch_type: '本科提前批',
            //             local_batch_id: '6',
            //             scl_count: 3,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         7: {
            //             local_batch_type: '本科一批',
            //             local_batch_id: '7',
            //             scl_count: 9,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         8: {
            //             local_batch_type: '本科二批',
            //             local_batch_id: '8',
            //             scl_count: 9,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         11: {
            //             local_batch_type: '专科提前批',
            //             local_batch_id: '11',
            //             scl_count: 3,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         10: {
            //             local_batch_type: '专科批',
            //             local_batch_id: '10',
            //             scl_count: 9,
            //             major_count: 6,
            //             plan_data: []
            //         }
            //     },
            //     '13': {
            //         6: {
            //             local_batch_type: '本科提前批',
            //             local_batch_id: '6',
            //             scl_count: 96,
            //             major_count: 1,
            //             plan_data: []
            //         },
            //         10: {
            //             local_batch_type: '专科批',
            //             local_batch_id: '10',
            //             scl_count: 96,
            //             major_count: 1,
            //             plan_data: []
            //         },
            //         14: {
            //             local_batch_type: '本科批',
            //             local_batch_id: '14',
            //             scl_count: 96,
            //             major_count: 1,
            //             plan_data: []
            //         }
            //     }
            // },
            savePlanObj: {},
            savePlanArr: [],
            activeIndex: '',
            activePlanObj: {},
            // batchKeyList: [6, 7, 8, 11, 10],
            planSpeList: [],
            planSchList: [],
            scrollTag: false,
            divWidth: false,
            optionsSchool: [
                { value: "31", label: "北京大学" },
                { value: "140", label: "清华大学" },
                { value: "132", label: "复旦大学" },
                { value: "59", label: "南开大学" },
                { value: "46", label: "中国人民大学" },
            ],
            optionsMajor: [
                { value: 299, label: "会计学-本科" },
                { value: 4, label: "经济学-本科" },
                { value: 8, label: "金融学-本科" },
                { value: 1, label: "哲学-本科" },
                { value: 14, label: "法学-本科" }
            ],
            optionsJob: [{
                value: "02090500",
                label: "幼儿教师"
            }, {
                value: "02060300",
                label: "会计人员"
            }, {
                value: "02050102",
                label: "外科医师"
            }, {
                value: "02040101",
                label: "飞行驾驶员"
            }, {
                value: "02080300",
                label: "律师"
            }],
            valueMajor: [],
            valueSchool: [],
            valueJob: [],
            typeMoreList: [{ type: '1', name: '学校' }, { type: '2', name: '专业' }, { type: '3', name: '职业' }],
            hoverMenuStatus: false,
            activeMoreIndex: 0,
            loading: false,
            // showPlanSmart: false,
            imitate_form: {}
        }
    },
    computed: {
        ...mapState({
            isZhiYuan: state => state.user.isZhiYuan,
            isLogin: state => state.user.isLogin,
            token: state => state.user.token,
            isVipStr: state => state.user.isVipStr,
            requestCount: state => state.user.requestCount,
            isShowGk: state => state.user.isShowGk,
            provinceCode: state => state.user.provinceCode,
            function_code: state => state.user.function_code
        }),
    },
    watch: {
        token(newVal) {
            if (newVal != '') {
                this.$store.commit('user/ADDCOUNT', 0);
                this.getHistoryDataHandler();
            }
        },
        provinceCode(newVal) {
            if (newVal != '' && localStorage.getItem("isProvince") == 'true') {
                this.initPlan()
                this.activePlanObj = {}
                this.getHistoryDataHandler();
            }
        },
        requestCount(newVal) {
            if (newVal > 0) {
                this.showBoxStatus = true;
            } else {
                this.showBoxStatus = false;
            }
        },
        isShowGk() {
            if (localStorage.getItem("isEdit") == 'true' && localStorage.getItem("isProvince") == 'false') {
                this.getPlanCountHandler()
                this.getHistoryDataHandler();
                this.schoolList = [];
                this.majorList = [];
                this.valueMajor = '';
                this.valueSchool = '';
                this.valueJob = '';
                // Object.assign(this.$data.savePlanObj, this.$options.data().savePlanObj)
                this.savePlanArr = [];
                this.activeIndex = '';
                this.activePlanObj = {};
                this.activeZybNames = [];
                this.activeDetNames = [];
                this.planSpeList = [];
                this.planSchList = [];
                this.totalData = 0;
                this.currentPage = 1;
                this.zybStatus = false;
                localStorage.setItem("isEdit", "false");
            }
        },
        isVipStr(newVal) {
            if (newVal == "true") {
                this.$store.commit('user/ADDCOUNT', 0);
                this.activeNames = [];
                this.getSchoolListHandler('1');
                this.activeCount = 10;
            }
        },
        function_code() {
            const tmp = this.function_code.filter(item => { return item.function_code === 'F00012'})
            if(tmp.length > 0) {
                this.has_code = tmp[0].has_code
            }
        }
    },
    filters: {
        planType(plan) {
            return plan.split('志愿')[0];
        }
    },
    created() {
        if (this.token == '') {
            this.getSearchDicHandler();
            this.showDataStatus = true;
            this.$store.commit('user/LOGINSTATUS', true);
            return
        }
        const data = localStorage.getItem("imitate_data")
        if(data) {
            const params = JSON.parse(data)
            this.imitate_form = params
            this.gkInfor = { ...this.imitate_form }
        }
        this.getPlanCountHandler()
        this.queryuserAgent();
        this.$store.commit('user/ADDCOUNT', 0);
        let type = this.$route.params.type;
        if (type == '1') {
            this.selectType = '3';
        } else if (type == '2') {
            this.selectType = '2';
        } else if (type == '3') {
            this.selectType = '1';
        } else {
            this.selectType = '1';
        }
        this.getSearchDicHandler();
        if(Object.keys(this.imitate_form).length > 0) {
            this.getVirtualHistoryData();
        } else {
            this.getHistoryDataHandler();
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('scroll', this.getScroll, true);
        });
        const tmp = this.function_code.filter(item => { return item.function_code === 'F00012'})
        if(tmp.length > 0) {
            this.has_code = tmp[0].has_code
        }
    },
    methods: {
        getPlanCountHandler() {
            getPlanCount().then(res => {
                this.batchKeyList = Object.keys(this.batchObj)
                for (const key in res.data) {
                    const element = res.data[key];
                    element.plan_data = []
                    element.local_batch_id = key
                }
                this.savePlanObj = res.data
                for (const key in this.batchObj) {
                    if (Object.hasOwnProperty.call(this.batchObj, key)) {
                        const element = this.batchObj[key];
                        for(let i = 1; i <= this.savePlanObj[key].scl_count; i++) {
                            let title_tmp = i
                            if(this.provinceCode !== '13') {
                                title_tmp = String.fromCharCode(64 + i)
                            }
                            const obj = {
                                plan_type: `${title_tmp}志愿`,
                                plan_scl: {},
                                specialty_data: []
                            }
                            this.savePlanObj[key].plan_data.push(obj)
                        }
                    }
                }
                localStorage.setItem("removePlanObj", JSON.stringify(this.savePlanObj));
            })
        },
        getScroll() {
            let div = document.getElementById('app')
            let top = div.scrollTop
            if (top > 300) {
                this.scrollTag = true;
            } else {
                this.scrollTag = false;
            }
        },
        queryuserAgent() {
            var userAgent = navigator.userAgent;
            if ((userAgent.indexOf("Safari") > -1 || userAgent.indexOf("iPhone") > -1) && userAgent.indexOf("Chrome") == -1) {
                this.divWidth = true;
            }
        },
        showGkInforHandler() {
            this.$store.commit('user/SHOWGKINFOR', true);
        },
        getHistoryDataHandler() {
            getHistoryData(localStorage.getItem("area")).then(res => {
                if (res.status == '200') {
                    if (!res.data) {
                        this.showDataStatus = true;
                    } else {
                        const data = res.data;
                        const subject = this.subjectObj[data.local_type_id];
                        const batch = this.batchObj[data.local_batch_type];
                        this.showAddZhiStatus = false;
                        this.gkInfor = data;
                        this.gkInfor = Object.assign({}, this.gkInfor, { subject: subject, batch: batch, section_line: data.section, count1: data.count3, count3: data.count1 });
                        this.$store.commit('user/EDITGKINFOR', this.gkInfor);
                        localStorage.setItem("savePlanArr1", JSON.stringify(this.savePlanObj));
                        this.selectPatch = this.gkInfor;
                        this.getScoreLineHandler();
                        this.activeNames = [];
                        this.getSchoolListHandler('1');
                    }
                } else {
                    this.$message({
                        message: '暂无数据，请重新填写信息',
                        type: 'error'
                    })
                    // this.$store.commit('user/EDITGKINFOR', {});
                    this.$store.commit('user/SHOWGKINFOR',true);
                    this.showDataStatus = true;
                    this.showBoxStatus = false;
                }
            })
        },
        getVirtualHistoryData() {
            getVirtualHistoryData(this.imitate_form).then(res => {
                if(res.status == 200) {
                    const data = res.data;
                    const subject = this.subjectObj[data.local_type_id];
                    const batch = this.batchObj[data.local_batch_type];
                    this.showAddZhiStatus = false;
                    this.gkInfor = data;
                    this.gkInfor = Object.assign({}, this.gkInfor, { subject: subject, batch: batch, section_line: data.section, count1: data.count3, count3: data.count1 });
                    this.$store.commit('user/EDITGKINFOR', this.gkInfor);
                    localStorage.setItem("savePlanArr1", JSON.stringify(this.savePlanObj));
                    this.selectPatch = this.gkInfor;
                    this.getScoreLineHandler();
                    this.activeNames = [];
                    this.getSchoolListHandler('1');
                    if(this.imitate_form.flag == 'edit') {
                        this.updateZhiyuanHandler();
                    }
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            })
        },
        handleChangeCard(e) {
            let type = parseInt(e.index) + 1;
            this.selectType = type.toString();
            this.schoolList = [];
            this.currentPage = 1,
                this.totalData = 0,
                this.activeNames = [];
            if (this.cardList[e.index].count > 0) {
                this.activeNames = [];
                this.getSchoolListHandler('1');
            }
        },
        linkShowState(linkShow) {
            this.linkShow = linkShow;
        },
        batchActiveHandler(index) {
            this.isBatchActive = index;
            const select_tmp = {
                batch: this.batchList[index].name,
                local_batch_type: this.batchList[index].local_batch_id
            }
            this.selectPatch = select_tmp;
            this.resetGetSchoolListHandler();
        },
        showSearchAllhandler() {
            this.showSearchAll = !this.showSearchAll;
        },
        activeTagHandler(item, index) {
            if(index == 0) {
                this.provinceList.map(item => {
                    item.flag = false
                })
                this.provinceList[0].flag = true
                this.selectProvince = []
            } else {
                this.provinceList[0].flag = false
                this.provinceList[index].flag = !this.provinceList[index].flag
                if(item.flag) {
                    this.selectProvince.push(this.provinceList[index].provinceid)
                } else {
                    const tmp = this.selectProvince.findIndex(val => {return val === item.provinceid})
                    this.selectProvince.splice(tmp, 1)
                }
            }
            this.resetGetSchoolListHandler();
        },
        activeTagHandler1(index) {
            this.activeTag1 = index;
            this.selectSclType = this.typeList[index].dic_code;
            this.resetGetSchoolListHandler();
        },
        activeTagHandler2(index) {
            this.activeTag2 = index;
            this.selectNature = this.typeList1[index].dic_code;
            this.resetGetSchoolListHandler();
        },
        activeTagHandler3(index) {
            this.activeTag3 = index;
            this.selectNatureType = this.typeList2[index].dic_code;
            this.resetGetSchoolListHandler();
        },
        resetGetSchoolListHandler() {
            this.schoolList = [];
            this.currentPage = 1,
            this.totalData = 0,
            this.activeNames = [];
            this.getSchoolListHandler('1');
        },
        addZhiYuanHandler(major, index, index1) {
            this.zybStatus = true;
            let savePlan = Object.assign({}, this.savePlanObj[this.selectPatch.local_batch_type]);
            let schoolInfor = this.schoolList[index];
            let majorList = schoolInfor.majorList;
            let planSpeList = Object.assign([], this.planSpeList);
            let planSchList = Object.assign([], this.planSchList);
            if (planSchList.indexOf(this.schoolList[index].scl_id) == -1) {
                let planArr = savePlan.plan_data.filter(item => item.plan_scl.scl_id);
                let flag = false;
                if (planArr.length == savePlan.scl_count) {
                        this.$message({
                        message: '该批次志愿已满',
                        type: 'warning'
                    });
                    return
                } 
            }
            let plan_scl = Object.assign({}, this.schoolListArr[index]);
            let plan_spe = major;
            this.activeDetNames = [];
            this.activeZybNames = [];
            let flag1 = '1'
            savePlan.plan_data.some((e) => {
                if(this.provinceCode !== '13') {
                    if (Object.keys(e.plan_scl).length == 0) {
                        if (e.specialty_data.length > savePlan.spec_count - 1) {
                            flag1 = '2'
                            return true
                        }
                        e.plan_scl = plan_scl;
                        e.specialty_data.push(plan_spe);
                        planSpeList.push(plan_spe.id);
                        planSchList.push(plan_scl.scl_id);
                        return true
                    } else {
                        if (e.plan_scl.scl_id == plan_scl.scl_id) {
                            if (e.specialty_data.length  > savePlan.spec_count - 1) {
                                flag1 = '2'
                                return true
                            }
                            e.specialty_data.push(plan_spe);
                            planSpeList.push(plan_spe.id);
                            return true
                        }
                    }
                } else {
                    if (Object.keys(e.plan_scl).length == 0) {
                        e.plan_scl = plan_scl;
                        e.specialty_data.push(plan_spe);
                        planSpeList.push(plan_spe.id);
                        planSchList.push(plan_scl.scl_id);
                        return true
                    }
                }
            })
            if (flag1 == '2' && this.provinceCode !== '13') {
                this.$message({
                    message: '该学校专业数量已达上限',
                    type: 'warning'
                });
            } else {
                majorList[index1].active = true;
                schoolInfor.majorList = majorList;
                this.$set(this.schoolList, index, schoolInfor);
            }
            const count = savePlan.plan_data.filter(item => { return Object.keys(item.plan_scl).length != 0 });
            savePlan.count = count.length;
            this.planSpeList = Object.assign([], planSpeList);
            this.planSchList = Object.assign([], planSchList);
            this.$set(this.savePlanObj, this.selectPatch.local_batch_type, savePlan);
            this.savePlanArr = Object.assign([], savePlan.plan_data);
            for (const el in this.savePlanObj) {
                if (this.savePlanObj[el].count > 0) {
                    this.activePlanObj[el] = this.savePlanObj[el];
                }
            }
            // for (let index = 0; index < count; index++) {
            //     this.activeZybNames.push(index.toString())
            // }
            let total_percent = 0
            let count_tmp = 0
            for (const key in this.activePlanObj) {
                if (Object.hasOwnProperty.call(this.activePlanObj, key)) {
                    let value = this.activePlanObj[key].plan_data;
                    for (const key1 in value) {
                        if (Object.hasOwnProperty.call(value, key1)) {
                            if (value[key1].specialty_data.length > 0) {
                                value[key1].specialty_data.map(item => {
                                    if (item.percent) {
                                        total_percent += item.percent
                                    }
                                    count_tmp++
                                })
                                this.activeDetNames.push(value[key1].plan_scl.scl_id)
                            }
                        }
                    }
                    this.activeZybNames.push(key.toString())
                }
            }
            this.activePlanObj.avg_percent = (total_percent / count_tmp).toFixed(0)
        },
        getScoreLineHandler() {
            const local_type_id = this.gkInfor.local_type_id;
            getScoreLine(local_type_id, localStorage.getItem("area")).then(res => {
                if (res.status != 200 || !res) {
                    return
                }
                const data = res.data.pro_score;
                this.batchList.forEach((item, index) => {
                    this.$set(this.batchList[index], 'grade', data[item.local_batch_id]);
                    this.$set(this.batchList[index], 'year', res.data.pro_year);
                    if (item.local_batch_id == this.gkInfor.local_batch_type) {
                        this.isBatchActive = index;
                    }
                })
            }).catch(error => {
                console.log(error);
            })
        },
        getSearchDicHandler() {
            try {
                getSearchDic().then(res => {
                    if (res.status != 200 || !res) {
                        return
                    }
                    res.data.province.map( item => {
                        item.flag = false
                        return item
                    })
                    this.provinceList.push(...res.data.province);
                    this.typeList.push(...res.data.scl_type);
                    this.typeList1.push(...res.data.scl_nature);
                    this.typeList2.push(...res.data.edu_type);
                }).catch(error => {
                    console.log(error);
                })
            } catch (error) { console.log(error) }
        },
        getSchoolListHandler(page) {
            this.activeNames = [];
            this.schoolList = [];
            const { score, local_type_id, section_line } = this.gkInfor;
            const local_batch_type = this.selectPatch.local_batch_type;
            const type = this.selectType;
            const province = this.selectProvince.join(',');
            const scl_type = this.selectSclType;
            const scl_nature = this.selectNature;
            const scl_nature_type = this.selectNatureType;
            const scl_ids = this.valueSchool;
            const special_ids = this.valueMajor;
            const job_codes = this.valueJob;
            let _this = this;
            try {
                getSchoolList(score, local_type_id, local_batch_type, type, province, scl_type, scl_nature, scl_nature_type, page, section_line, localStorage.getItem("area"), scl_ids, special_ids, job_codes).then(async res => {
                    if (res.status != 200) {
                        this.cardList = [
                            { name: '需冲刺', count: '--', type: '1' },
                            { name: '较稳妥', count: '--', type: '2' },
                            { name: '可保底', count: '--', type: '3' }
                        ];
                        this.showDataStatus = true;
                        this.showBoxStatus = false;
                        return
                    }
                    this.showDataStatus = false;
                    this.showBoxStatus = false;
                    this.$set(this.cardList[0], 'count', res.data.count1);
                    this.$set(this.cardList[1], 'count', res.data.count2);
                    this.$set(this.cardList[2], 'count', res.data.count3);
                    if (res.data.count1 <= 3) {
                        this.$set(this.cardList[0], 'activeCount', res.data.count1);
                    } else {
                        this.$set(this.cardList[0], 'activeCount', 3);
                    }
                    if (res.data.count2 <= 3) {
                        this.$set(this.cardList[1], 'activeCount', res.data.count2);
                    } else {
                        this.$set(this.cardList[1], 'activeCount', 3);
                    }
                    if (res.data.count3 <= 3) {
                        this.$set(this.cardList[2], 'activeCount', res.data.count3);
                    } else {
                        this.$set(this.cardList[2], 'activeCount', 3);
                    }
                    if (!res.data || res.data.data.length == 0) {

                    } else {
                        const data = res.data.data;
                        const schoolList = [];
                        const schoolListArr = [];
                        data.forEach((item, index) => {
                            let obj = {};
                            let school_type = '';
                            let school_nature = '';
                            let school_nature_type = '';
                            obj = Object.assign({}, item);
                            if (item.scl_type == '5000') {
                                school_type = '综合'
                            } else if (item.scl_type == '5001') {
                                school_type = '理工'
                            } else if (item.scl_type == '5002') {
                                school_type = '农林'
                            } else if (item.scl_type == '5003') {
                                school_type = '医药'
                            } else if (item.scl_type == '5004') {
                                school_type = '师范'
                            } else if (item.scl_type == '5005') {
                                school_type = '语言'
                            } else if (item.scl_type == '5006') {
                                school_type = '财经'
                            } else if (item.scl_type == '5007') {
                                school_type = '政法'
                            } else if (item.scl_type == '5008') {
                                school_type = '体育'
                            } else if (item.scl_type == '5009') {
                                school_type = '艺术'
                            } else if (item.scl_type == '5010') {
                                school_type = '民族'
                            } else if (item.scl_type == '5011') {
                                school_type = '军事'
                            } else {
                                school_type = '其他'
                            }
                            if (item.scl_nature == '36000') {
                                school_nature = '公办'
                            } else if (item.scl_nature == '36001') {
                                school_nature = '民办'
                            }
                            if (item.scl_nature_type == '6000') {
                                school_nature_type = '普通本科'
                            } else if (item.scl_nature_type == '6001') {
                                school_nature_type = '普通专科'
                            } else if (item.scl_nature_type == '6002') {
                                school_nature_type = '中外合作办学'
                            }
                            obj.school_type = school_type;
                            obj.school_nature = school_nature;
                            obj.school_nature_type = school_nature_type;
                            schoolList.push(obj);
                            schoolListArr.push(item);
                        })
                        this.schoolListArr = schoolListArr;
                        this.schoolList = schoolList;
                        this.isVip = res.data.is_vip;
                        this.totalData = res.data['count' + type];
                    }
                }).catch(error => {
                    console.log(error);
                })
            } catch (error) { console.log(error) }
        },
        getSpecialListHandler(index, scl_id, year) {
            const { score, local_type_id } = this.gkInfor;
            const local_batch_type = this.selectPatch.local_batch_type;
            const type = this.selectType;
            const special_ids = this.valueMajor;
            const job_codes = this.valueJob;
            getSpecialList(scl_id, year, score, local_type_id, local_batch_type, type, localStorage.getItem("area"), special_ids, job_codes).then(res1 => {
                let majorList = res1.data.data;
                let majorNewList = [];
                let planSpeList = Object.assign([], this.planSpeList);
                let planSchList = Object.assign([], this.planSchList);
                const schoolNewList = this.schoolList;
                majorList.forEach(((item1) => {
                    if (planSpeList.indexOf(item1.id) != -1 && planSchList.indexOf(scl_id) != -1) {
                        majorNewList.push(Object.assign({}, item1, {
                            active: true,
                        }))
                    } else {
                        majorNewList.push(Object.assign({}, item1, {
                            active: false,
                        }))
                    }
                }))
                schoolNewList[index].majorList = majorNewList;
                this.schoolList = Object.assign([], schoolNewList);
            })
        },
        schoolDetailHandler(scl_id) {
            const { href } = this.$router.resolve({
                name:'school-detail',
                query: {
                    scl_id: scl_id
                }
            })
            window.open(href, '_blank')
        },
        draggableSchoolList(e) {
            try {
                let index = e.target.dataset.index;
                let activePlanArr = JSON.parse(localStorage.getItem("savePlanArr1"))[index].plan_data;
                let activePlan = [...this.activePlanObj[index].plan_data];
                const activeNewPlan = activePlan.map((item, index) => {
                    item.plan_type = activePlanArr[index].plan_type;
                    return item;
                })
                this.$set(this.activePlanObj[index], 'plan_data', activeNewPlan);
            } catch (error) {
                console.log(error)
            }
        },
        deleteSchoolhandler(school, index1, activeSchoolIndex) {
            const schoolList = this.schoolList;
            let count = this.activePlanObj[activeSchoolIndex].count;
            let indexSchool = index1;
            let deleteIndexSchool = this.planSchList.indexOf(school.plan_scl.scl_id);
            let majorList = [];
            majorList = [...school.specialty_data];
            majorList.map(item => {
                item.active = false;
                let indexSpe = this.planSpeList.indexOf(item.id);
                if (indexSpe != -1) {
                    this.planSpeList.splice(indexSpe, 1);
                }
                return item;
            });
            const findSchoolIndex = schoolList.findIndex(item => item.scl_id == school.plan_scl.scl_id);
            if (findSchoolIndex != -1) {
                const majorListArr = schoolList[findSchoolIndex].majorList;
                if(majorListArr) {
                    majorListArr.map(item => {
                        item.active = false;
                        return item;
                    });
                    schoolList[findSchoolIndex].majorList = majorListArr;
                }
            }
            if (deleteIndexSchool != -1) {
                this.planSchList.splice(deleteIndexSchool, 1);
                count--;
            }
            let activePlan = this.activePlanObj[activeSchoolIndex].plan_data;
            let activePlanArr = JSON.parse(localStorage.getItem("savePlanArr1"))[activeSchoolIndex].plan_data;
            activePlan[indexSchool].plan_scl = {};
            activePlan[indexSchool].specialty_data = [];
            const activeNewPlan = activePlan.filter(item => item.specialty_data.length != 0);
            const activeNewPlanArr = activePlanArr.map((item, index) => {
                if (activeNewPlan[index]) {
                    item.plan_scl = activeNewPlan[index].plan_scl;
                    item.specialty_data = activeNewPlan[index].specialty_data;
                }
                return item;
            })
            activePlan = [...activeNewPlan];
            this.$set(this.activePlanObj[activeSchoolIndex], 'count', count);
            this.$set(this.activePlanObj[activeSchoolIndex], 'plan_data', activeNewPlanArr);
            const countSum = [];
            let total_percent = 0
            let count_tmp = 0
            for (const i in this.activePlanObj) {
                const count = this.activePlanObj[i].count;
                let plan_data = this.activePlanObj[i].plan_data || [];
                if(plan_data.length > 0) {
                    plan_data.map(item => {
                        if (item.specialty_data.length > 0) {
                            item.specialty_data.map(item1 => {
                                if (item1.percent) {
                                    total_percent += item1.percent
                                }
                                count_tmp++
                            })
                        }
                    })
                }
                if (count) {
                    countSum.push(count)
                }
            }
            this.activePlanObj.avg_percent = (total_percent / count_tmp).toFixed(0)
            if (countSum.length == 0) {
                this.zybStatus = false;
            }
        },
        deleteMajorhandler(index, index1, index2, key, school, major) {
            const schoolList = [...this.schoolList];
            let deleteIndexSchool = schoolList.findIndex(item => item.scl_id == school.plan_scl.scl_id);
            if (deleteIndexSchool != -1 && schoolList[deleteIndexSchool].majorList) {
                let majorList = [...schoolList[deleteIndexSchool].majorList];
                let deleteIndexMajor = majorList.findIndex(item => item.id == major.id);
                if(deleteIndexMajor !== -1) {
                    majorList[deleteIndexMajor].active = false;
                }
            }
            let planSpeList = this.planSpeList;
            let planSchList = this.planSchList;
            if (planSpeList.indexOf(major.id) != -1 && planSchList.indexOf(school.plan_scl.scl_id) != -1) {
                planSpeList.splice(planSpeList.findIndex(item => item === major.id), 1)
            }
            let specialty_data = this.savePlanObj[key].plan_data[index1].specialty_data;
            specialty_data.splice(index2, 1);
            if (specialty_data.length == 0) {
                this.savePlanObj[key].plan_data[index1].plan_scl = {};
                this.savePlanObj[key].count--;
            }
            const countSum = [];
            let total_percent = 0
            let count_tmp = 0
            for (const i in this.activePlanObj) {
                const count = this.activePlanObj[i].count;
                const plan_data = this.activePlanObj[i].plan_data;
                if(plan_data) {
                    plan_data.map(item => {
                        if (item.specialty_data.length > 0) {
                            item.specialty_data.map(item1 => {
                                if (item1.percent) {
                                    total_percent += item1.percent
                                }
                                count_tmp++
                            })
                        }
                    })
                }
                if (count) {
                    countSum.push(count)
                }
            }
            if (countSum.length == 0) {
                this.zybStatus = false;
                this.activePlanObj.avg_percent = 0;
                return
            }
            this.activePlanObj.avg_percent = (total_percent / count_tmp).toFixed(0)
            if (specialty_data.length == 0) {
                for (let i = index1; i < this.savePlanObj[key].plan_data.length; i++) {
                    if (i == this.savePlanObj[key].plan_data.length - 1) {
                        this.savePlanObj[key].plan_data[i].specialty_data = [];
                        this.savePlanObj[key].plan_data[i].plan_scl = {};
                        break
                    }
                    let specialty_data = this.savePlanObj[key].plan_data[i + 1].specialty_data;
                    let plan_scl = this.savePlanObj[key].plan_data[i + 1].plan_scl;
                    this.savePlanObj[key].plan_data[i].specialty_data = specialty_data;
                    this.savePlanObj[key].plan_data[i].plan_scl = plan_scl;
                }
            }
        },
        activeVipHandler() {
            localStorage.setItem("isNewUser", "false");
            this.$store.commit('user/SHOWVIP', true);
        },
        removePlanHandler() {
            this.zybStatus = false;
            this.savePlanObj = JSON.parse(localStorage.getItem("removePlanObj"));
            this.activePlanObj = {};
            this.activeZybNames = [];
            this.activeDetNames = [];
            this.planSpeList = [];
            this.planSchList = [];
            const schoolList = this.schoolList;
            schoolList.map(item => {
                const majorList = item.majorList;
                if (majorList) {
                    majorList.map(item1 => {
                        item1.active = false;
                    })
                }
            })
        },
        savePlanHandler() {
            if(this.has_code == 0) {
                this.$message({
                    message: '您的账户暂未开通此功能',
                    type: 'warning'
                })
                return
            }
            this.$store.commit("user/SHOWSAVEPLAN", true);
            let plan = { ...this.savePlanObj };
            const savePlanInfor = {}
            let total_percent = 0
            let count_tmp = 0
            for (const i in plan) {
                plan[i].batch_show = false;
                let plan_data = plan[i].plan_data;
                let findIndex = plan_data.findIndex(item => item.specialty_data.length > 0)
                if (findIndex != -1) {
                    plan[i].is_plan = true;
                } else {
                    plan[i].is_plan = false;
                }
                if(plan_data.length > 0) {
                    plan_data.map(item => {
                        if (item.specialty_data.length > 0) {
                            item.specialty_data.map(item1 => {
                                if (item1.percent) {
                                    total_percent += item1.percent
                                }
                                count_tmp++
                            })
                        }
                    })
                }
            }
            savePlanInfor.avg_percent = (total_percent / count_tmp).toFixed(0)
            let tmp = {}
            if(Object.keys(this.imitate_form).length > 0) {
                const plan_base_info = {
                    subject_type: this.imitate_form.subject,
                    exam_name: this.imitate_form.exam_name,
                    exam_score: this.imitate_form.exam_score,
                    score_adjust: this.imitate_form.adjust_score
                }
                tmp = {
                    plan_type: '1',
                    plan_desc: this.imitate_form.subject + '/' + this.imitate_form.score,
                    plan_base_info: plan_base_info
                }
            } else {
                tmp = {
                    plan_type: '0',
                    plan_desc: this.gkInfor.subject + '/' + this.gkInfor.score,
                    plan_base_info: {}
                }
            }
            Object.assign(tmp, this.gkInfor)
            Object.assign(savePlanInfor, tmp)
            savePlanInfor.json_str = this.savePlanObj
            savePlanInfor.flag = this.imitate_form.flag || ''
            savePlanInfor.id = this.imitate_form.id || ''
            savePlanInfor.plan_title = this.imitate_form.plan_title || ''
            savePlanInfor.exam_name = this.imitate_form.exam_name || ''
            this.$store.commit("user/EDITSAVEPLANINFOR", savePlanInfor);
        },
        changeSearchTypeHandler(index) {
            this.activeMoreIndex = index;
            this.valueMajor = '';
            this.valueSchool = '';
            this.valueJob = '';
        },
        hoverMenuHandler() {
            this.hoverMenuStatus = !this.hoverMenuStatus;
        },
        getSearchSchoolListHandler(query) {
            if (query == '') {
                return
            }
            this.loading = true;
            getSearchSchoolList(query).then(res => {
                this.loading = false;
                let list = [];
                list = res.data.map((item, index) => {
                    return { value: `${item.scl_id}`, label: `${item.scl_name}` };
                });
                this.optionsSchool = list;
            })
        },
        geSearchSpecialListHandler(query) {
            if (query == '') {
                return
            }
            this.loading = true;
            geSearchSpecialList(query).then(res => {
                this.loading = false;
                let list = [];
                list = res.data.map((item, index) => {
                    return { value: `${item.special_id}`, label: `${item.special_name}` };
                });
                this.optionsMajor = list;
            })
        },
        getSearchJobListHandler(query) {
            if (query == '') {
                return
            }
            this.loading = true;
            getSearchJobList(query).then(res => {
                this.loading = false;
                let list = [];
                list = res.data.map((item, index) => {
                    return { value: `${item.job_code}`, label: `${item.job_name}` };
                });
                this.optionsJob = list;
            })
        },
        // planSmartHandler() {
        //     this.showPlanSmart = true
        // },
        // planSmartSubmitHandler() {
        //     this.savePlanObj = JSON.parse(localStorage.getItem("removePlanObj"));
        //     this.activePlanObj = {};
        //     this.activeZybNames = [];
        //     this.activeDetNames = [];
        //     this.planSpeList = [];
        //     this.planSchList = [];
        //     let savePlan = Object.assign({}, this.savePlanObj[this.selectPatch.local_batch_type]);
        //     const schoolList = this.schoolList;
        //     let planSpeList = [];
        //     let planSchList = [];
        //     schoolList.map(item => {
        //         const majorList = item.majorList;
        //         if (majorList) {
        //             majorList.map(item1 => {
        //                 item1.active = false;
        //             })
        //         }
        //     })
        //     const data = {
        //         score: this.gkInfor.score,
        //         local_type_id: this.gkInfor.local_type_id,
        //         local_batch_type: this.selectPatch.local_batch_type
        //     }
        //     planSmartSubmit(data).then(res => {
        //         this.showPlanSmart = false
        //         let sclTmp = res.data
        //         if(sclTmp.length === 0) {
        //             return
        //         }
        //         this.zybStatus = true
        //         sclTmp.map((item, index) => {
        //             savePlan.plan_data[index].plan_scl = item.scl_info
        //             const sclIndex = schoolList.findIndex(val => { return val.scl_id === item.scl_info.scl_id })
        //             item.specialty_data.map((item1,index1) => {
        //                 savePlan.plan_data[index].specialty_data[index1] = item1
        //                 if(sclIndex !== -1 && schoolList[sclIndex].majorList) {
        //                     const majorIndex = schoolList[sclIndex].majorList.findIndex(val => { return val.id === item1.id })
        //                     if(majorIndex !== -1) {
        //                         schoolList[sclIndex].majorList[majorIndex].active = true
        //                     }
        //                 }
        //                 planSpeList.push(item1.id);
        //             })
        //             planSchList.push(item.scl_info.scl_id);
        //         })
        //         this.activeDetNames = [];
        //         this.activeZybNames = [];
        //         const count = savePlan.plan_data.filter(item => { return Object.keys(item.plan_scl).length != 0 });
        //         savePlan.count = count.length;
        //         this.planSpeList = Object.assign([], planSpeList);
        //         this.planSchList = Object.assign([], planSchList);
        //         this.$set(this.savePlanObj, this.selectPatch.local_batch_type, savePlan);
        //         this.savePlanArr = Object.assign([], savePlan.plan_data);
        //         for (const el in this.savePlanObj) {
        //             if (this.savePlanObj[el].count > 0) {
        //                 this.activePlanObj[el] = this.savePlanObj[el];
        //             }
        //         }
        //         // for (let index = 0; index < count; index++) {
        //         //     this.activeZybNames.push(index.toString())
        //         // }
        //         let total_percent = 0
        //         let count_tmp = 0
        //         for (const key in this.activePlanObj) {
        //             if (Object.hasOwnProperty.call(this.activePlanObj, key)) {
        //                 let value = this.activePlanObj[key].plan_data;
        //                 for (const key1 in value) {
        //                     if (Object.hasOwnProperty.call(value, key1)) {
        //                         if (value[key1].specialty_data.length > 0) {
        //                             value[key1].specialty_data.map(item => {
        //                                 if (item.percent) {
        //                                     total_percent += item.percent
        //                                 }
        //                                 count_tmp++
        //                             })
        //                             this.activeDetNames.push(value[key1].plan_scl.scl_id)
        //                         }
        //                     }
        //                 }
        //                 this.activeZybNames.push(key.toString())
        //             }
        //         }
        //         this.activePlanObj.avg_percent = (total_percent / count_tmp).toFixed(0)
        //     })
        // },
        updateZhiyuanHandler() {
            const data = this.imitate_form
            const savePlan = JSON.parse(data.plan_info)
            let planSpeList = Object.assign([], this.planSpeList);
            let planSchList = Object.assign([], this.planSchList);
            this.zybStatus = true
            let total = 0
            for (const key in savePlan) {
                if (savePlan.hasOwnProperty(key)) {
                    const element = savePlan[key]
                    element.count = 0
                    if(element.is_plan) {
                        let count = 0
                        total++
                        element.plan_data.map(item => {
                            if(Object.keys(item.plan_scl).length > 0) {
                                planSchList.push(item.plan_scl.scl_id);
                                count++
                                if(item.specialty_data.length > 0) {
                                    this.activeDetNames.push(item.plan_scl.scl_id)
                                    item.specialty_data.map(item1 => {
                                        planSpeList.push(item1.id);
                                        
                                    }) 
                                }
                            }
                        })
                        element.count = count
                        this.activeZybNames.push(key.toString())
                        this.activePlanObj[key] = element
                    }
                }
            }
            this.planSpeList = Object.assign([], planSpeList);
            this.planSchList = Object.assign([], planSchList);
            this.activePlanObj.avg_percent = data.avg_percent;
            this.savePlanObj = savePlan;
            // localStorage.setItem("removePlanObj", JSON.stringify(this.savePlanObj));
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.zy-img {
    @include gwidth;
    margin-top: 10px;
}

.zy-school {
    @include gwidth;

    .el-col-7 {
        width: 32.5%;
    }

    .el-col-16 {
        position: relative;
        padding-right: 10px;
    }
}

.rank-box {
    border: none;
    background: #f5f7fa;
    box-shadow: none !important;
    margin-top: 24px;
}

.zy-text {
    color: #2c2e33;
    position: absolute;
    top: 30px;
    right: 28px;
    z-index: 99;
    font-size: 14px;
    cursor: pointer;

    span {
        width: 1px;
        height: 14px;
        background: #c4c7cc;
        border-radius: 1px;
        display: inline-block;
        margin: 0px 3px;
        position: relative;
        top: 1px;
    }

    a {
        color: $common-color;
    }

    .el-icon-arrow-down,
    .el-icon-arrow-up {
        margin-right: 20px;
    }

    .el-icon--right {
        margin-left: -3px;
    }

    .con-score-span {
        position: absolute;
        display: inline-block;
        right: -22px;
        width: 28px;
        height: 28px;
        background: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 1px 2px 0px rgba(44, 46, 51, 0.10);
    }

    .con-score-section {
        font-size: 12px;
        font-weight: 400;
        color: #909399;
        margin-top: 6px;
        position: relative;
        left: -22px;
    }

    .con-score-span img {
        width: 14px;
        height: 14px;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

.province-list {
    @include gflex;
    font-size: 0;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 6px;

    .title-box {
        width: 78px;
        font-size: 14px;
        text-align: right;
        color: #909399;
        margin-top: 3px;
    }

    a {
        display: inline-block;
        font-size: 14px;
        color: #5e6166;
        cursor: pointer;
        text-align: center;
        margin-bottom: 10px;
        padding: 3px 5px;
    }

    a:not(:nth-child(13n)) {
        margin-right: 12px;
    }

    .active-tag {
        color: #ffffff !important;
        background: $common-color;
        border-radius: 4px;
    }

    a:hover {
        color: $common-color;
    }

    .province-name {
        @include gflex;
        width: calc(100% - 4px);
        justify-content: flex-start;
        flex-wrap: wrap;
    }
}

.choice-box {
    font-size: 14px;
    margin-top: 4px;
    color: $common-color;
    cursor: pointer;

    i {
        margin-left: 5px;
    }
}

.collapse-box {
    width: 100%;
    font-size: 0;

    img,
    .el-image {
        width: 64px;
        height: 64px;
        margin-top: 5px;
    }

    .el-col-3 {
        width: 11%;
    }

    >.el-col-4 {
        float: right;
    }

    .zytb-school-name {
        font-size: 18px;
        font-weight: 600;
        color: #2c2e33;
        margin-bottom: 5px;
    }
    .zytb-school-tag span {
        display: inline-block;
        padding: 3px 8px;
        font-size: 12px;
        color: #909399;
        height: 22px;
        background: #f0f2f5;
        border-radius: 4px;
        line-height: 22px;
        margin-right: 4px;
    }

    .zytb-school-count {
        margin-top: -3px;
    }

    .zytb-school-count-diff {
        position: relative;
        top: 14px;
    }

    .zytb-school-count span {
        font-size: 12px;
        color: #909399;
        margin-right: 12px;
        font-weight: 400;
    }

    .zytb-school-fx-1 {
        background: #fe9f0a;

        span {
            color: #fe9f0a;
        }
    }

    .zytb-school-fx-2 {
        background: #3272ff;
        padding-bottom: 7px;

        span {
            color: #3272ff;
        }
    }

    .zytb-school-fx-3 {
        background: #139b83;
        padding-bottom: 7px;

        span {
            color: #139b83;
        }
    }

    .zytb-school-fx {
        width: 117px;
        height: 61px;
        border-radius: 4px;
        font-size: 12px;
        text-align: center;
        padding: 2px;
        box-sizing: border-box;
        float: right;
        display: flex;
        color: #ffffff;

        .zytb-school-tj {
            background: #ffffff;
            width: 55px;
            height: 57px;
            background: #ffffff;
            border-radius: 2px;
            box-sizing: border-box;

            div {
                color: #909399;
                font-size: 12px;
            }
        }

        .zytb-school-ms {
            padding-left: 6px;
            line-height: 18px;
            display: flex;
            align-items: center;
        }

        span {
            font-size: 24px;
        }

        .zytb-school-fx-span {
            font-size: 14px;
        }
    }

    .zytb-school-major {
        color: $common-color;
        font-size: 14px;
        margin-top: 12px;
        position: relative;
        right: 28px;
        text-align: right;
    }
}

.collapse-box-diff {
    .el-col-18 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 75%;
        width: auto;
    }

    .zytb-school-name .el-col-4>span {
        display: inline-block;
        // padding: 0px 0px 5px 0px;
        font-size: 16px;
        color: $common-color;
        width: 64px;
        height: 46px;
        background: #f5f7fa;
        border-radius: 4px;
        margin-left: 4px;
        text-align: center;
        box-sizing: border-box;

        div {
            font-size: 12px;
            color: #999390;
            margin-top: -5px;
        }
    }

    button {
        min-width: 86px;
        height: 30px;
        line-height: 26px;
        border: 1px solid $common-color;
        border-radius: 5px;
        color: $common-color;
        text-align: center;
        background-color: #fff;
        font-size: 14px;
        float: right;
        margin-top: 10px;
        position: relative;

        img {
            width: 14px;
            height: 14px;
            top: 2px;
            left: 13px;
            position: absolute;
        }
    }

    .zytb-school-btn {
        background: $common-color !important;
        color: #fff !important;
        text-align: right;
        padding-right: 8px;
    }
}

.collapse-box-diff:not(:last-child) {
    margin-bottom: 24px;
}

.zy-active {
    font-size: 16px;
    width: 100%;
    height: 152px;
    text-align: center;
    position: absolute;
    bottom: 24px;
    left: 0;

    p {
        margin-top: 33px;
    }

    span {
        display: inline-block;
        color: #FF861D;
    }

    button {
        width: 96px;
        height: 40px;
        border: none;
        background: linear-gradient(133deg, #ffce5d 1%, #ffa02f 97%, #ffa02f 97%);
        border-radius: 5px;
        color: #ffffff;
        margin-top: 10px;
    }
}

.zyb-box {
    position: relative;
    right: 0;
    // top: 72px;
    margin-bottom: 20px;
    height: 622px;

    .zyb-title {
        height: 56px;
        border-bottom: 1px solid #f0f2f5;
    }

    .zyb-avg-percent {
        height: 32px;
        background: #f5f7fa;
        border-radius: 4px;
        font-size: 14px;
        color: #909399;
        line-height: 32px;
        margin-top: 8px;
        padding: 0 12px;
        span {
            color: $common_color
        }
    }

    .no-data-box {
        margin-top: 0;
    }

    .zyb-img {
        width: 24px;
        height: 24px;
        position: relative;
        top: 4px;
    }

    .el-col-20 {
        color: #2c2e33;
        font-size: 22px;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-col-4 {
        color: $common-color;
        font-size: 16px;
        text-align: right;
        line-height: 22px;
        cursor: pointer;
        margin-top: 4px;
    }

    .zyb-major {
        position: relative;

        .zy-type {
            color: $common-color;
            font-weight: 600;
            font-size: 20px;
            width: 48px;
            height: 50px;
            background: #f5f7fa;
            border-radius: 4px;
            text-align: center;
            padding-top: 4px;
            box-sizing: border-box;
            margin-top: -4px;

            div {
                font-size: 12px;
            }
        }

        .el-col-20 {
            color: $common-color;
            font-size: 16px;
            font-weight: 400;
        }

        .tzy-collapse-item {
            .el-col-1 {
                text-align: right;
                width: 7%;
            }
        }

        img {
            width: 10px;
            height: 10px;
        }
    }

    button {
        color: #ffffff;
        font-size: 18px;
        width: 100%;
        height: 52px;
        background: linear-gradient(90deg, #ffa94a, #ff913c);
        border-radius: 0px 0px 10px 10px;
        position: relative;
        bottom: 52px;
        border: 1px solid #ffa94a;
    }
    // .add-zyb-btn {
    //     display: flex;
    //     button {
    //         width: 50%;
    //         margin: 0;
    //     }
    //     button:first-child {
    //         border-radius: 0px 0px 0px 10px;
    //         background: linear-gradient(270deg, #4c93ff, #4a9eff 99%);
    //         border: 1px solid #4a9eff;
    //     }
    //     button:last-child {
    //         border-radius: 0px 0px 10px 0px;
    //     }
    // }
}

.el-menu {
    width: 260px !important;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 1px 6px 0px rgba(51, 55, 61, 0.20);
    padding: 0 12px;
    box-sizing: border-box;
    position: absolute;
    right: 20px;
    margin-top: -14px;
    z-index: 999;
    -webkit-transition: -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);
    transition: transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);
    text-align: center;

    li {
        color: #2c2e33;
        font-size: 14px;
        height: 44px;
        line-height: 44px;
        @include gflex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f0f2f5;
        
        img {
            width: 20px;
            height: 20px;
        }
    }

    // li:not(:last-child) {
    //     border-bottom: 1px solid #f0f2f5;
    // }

    .major-patch {
        color: #c4c7cc;
    }

    .major-patch-bkx {
        color: #909399;
    }
}

.no-data-box {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 80px;

    img {
        width: 110px;
        height: 110px;
    }

    p {
        font-size: 16px;
        text-align: center;
        color: #abaeb3;
    }
}

.no-data-box-diff {
    top: 60%;
}

.no-data-content {
    border-bottom: 1px solid #f0f2f5;
    padding-bottom: 24px;
}

.zyb-draggable {
    margin: 0;
    padding: 0;
}

.el-item-diff {
    -webkit-filter: blur(15px);
    -moz-filter: blur(15px);
    -o-filter: blur(15px);
    -ms-filter: blur(15px);
    filter: blur(15px);
}

.zyb-major-infor {
    span {
        display: inline-block;
    }

    .zyb-major-title {
        font-size: 14px;
        color: #2c2e33;
        font-weight: 400;
        width: 80%;
        display: inline-block;
        overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }

    .zyb-major-delete {
        color: #ee4444;
        font-size: 14px;
        float: right;
        cursor: pointer;
    }
}

.zyb-major-percent {
    font-size: 12px;
    color: #999390;
    line-height: 17px;
    span {
        color: $common_color
    }
}

.fixed-top {
    position: fixed;
    top: -16px;
    right: calc(50% - 592px);
    width: 384px !important;
}

@media screen and (max-width: 1280px) {
    .fixed-top {
        position: fixed;
        top: -16px;
        right: 0;
        width: 384px !important;
    }
}

.zyb-bar {
    height: 500px;
    width: calc(100%);
}

.el-col-22 {
    width: 91%;
}

.zyb-batch-diff {
    width: 95%;
}

.zyb-batch-diff1 {
    width: 98.7%;
}

.zy-search {
    width: 100%;
    height: 44px;
    background: #ffffff;
    border: 1px solid #e1e4eb;
    border-radius: 8px;
    margin-bottom: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;

    img {
        position: absolute;
        right: 10px;
        top: 5px;
        cursor: pointer;
    }

    .el-col-4 {
        width: 74px;
        border-right: 1px solid #e1e4eb;
        color: #66605e;
        font-size: 16px;
        position: relative;
        cursor: pointer;
        height: 30px;
        line-height: 30px;

        span {
            margin-left: 4px;
            color: #c4c7cc;
        }

        .el-icon-arrow-up {
            color: $common-color;
        }
    }
}

.menu-tools-ul {
    position: absolute;
    height: auto;
    min-width: 80px;
    padding: 10px;
    z-index: 9999;
    color: #5e6166;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    line-height: 35px;
    box-sizing: border-box;
    left: -16px;
    top: 36px;
    margin-top: -8px;
    background: rgba(255, 255, 255, 0.80);
    border-radius: 10px;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.10);
    backdrop-filter: blur(6px);

    .menu-li {
        color: #332e2c !important;
        font-size: 18px;
        font-weight: 600;
    }

    li {
        padding: 0;
        list-style: none;
        cursor: pointer;
    }

    li:hover {
        color: $common-color;
    }
}
.dialog-box {
    img {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 40px;
        top: 40px;
        z-index: 999;
    }
    p {
        margin: 40px 0;
        color: #5e6166;
        font-size: 16px;
        position: relative;
        z-index: 9999;
        text-align: left;
        margin: 0;
        line-height: 30px;
    }
    .dialog-footer {
        padding: 0;
        button {
            width: 240px;
            height: 52px;
            border-radius: 8px;
            font-size: 18px!important;
            border: none;
            margin-bottom: 30px;
            top: 40px;
        }
        .vip-btn1 {
            background: #e1e4eb!important;
            color: #5e6166!important;
            background: #e1e4eb!important;
            position: relative;
            left: -10px;
        }
        .vip-btn2 {
            background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
            color: #ffffff!important;
            position: relative;
            right: -10px;
        }
    }
}
</style>